<div class="resp-container">
  <div class="resp-iframe">
    <div #map id="map" class="map"></div>
  </div>
</div>
